export const GET_FILES = "GET_FILES";
export const UPLOAD_FILES = "UPLOAD_FILES";
export const DELETE_FILES = "DELETE_FILES";
